import { UPDATE_USER_GROUP } from 'stores/redux/actions/types';
import reducer from '../common/reducer';

const addReducer = reducer(UPDATE_USER_GROUP, '');
export default addReducer;
